import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { Navigator, Page, Toolbar, BackButton } from "react-onsenui";
import { useReactPWAInstall } from "react-pwa-install";

import LoginScreen from "./components/LoginScreen";
import OTPScreen from "./components/OTPScreen";
import HomeScreen from "./components/HomeScreen";
import SplashScreen from "./components/SplashScreen";
import myLogo2 from "./ratifi-2.png";
import RegistrationScreen from "./components/RegistrationScreen";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'onsenui/css/onsenui.css';
import 'onsenui/css/onsen-css-components.css';



function App() {
  const { pwaInstall, supported, isInstalled } = useReactPWAInstall();

  const [isLoggedIn, setIsLoggedIn] = useState(false); // keycloack fix
  const [isLoading, setIsLoading] = useState(true); // keycloack fix Show splash screen initially
  const [isInstalling, setIsInstalling] = useState(false);
  const [installError, setInstallError] = useState(false);

  // already done
  const [appInstalled,setAppInstalled]=useState(false); //keycloack fix

  // Simulate token check and initial loading
  useEffect(() => {
    const token = Cookies.get("RATIFI_REDUX_TOKEN");
    if (true) {
      setIsLoggedIn(true);
    }
    setTimeout(() => setIsLoading(false), 500); // Simulated delay
  }, []);

  // Handle installation from URL flag
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const installFlag = urlParams.get("install");
    // alert(isInstalled())
    // if(installFlag && isInstalled()===true){
    //   alert("Please operate from App")
    //   return ;
    // }
    if (installFlag === "true" ) {
      handleInstall();
    }


  }, [pwaInstall]);

  const handleInstall = () => {
    setIsInstalling(true);
    setInstallError(false);

    pwaInstall({
      title: "Install RatiFi Redux",
      description: "Simple, Fast & Scalable",
      logo: myLogo2,
    })
      .then(() => {
        console.log("App installed successfully");
        setIsInstalling(false);
        setAppInstalled(true);
   
      })
      .catch((err) => {
        console.error("App installation failed", err);
        setInstallError(true);
        // setIsInstalling(false);
      });
  };

  const renderToolbar = (title, navigator) => (
    <Toolbar>
      <div className="left">
        <BackButton  />
      </div>
      <div className="center">{title}</div>
    </Toolbar>
  );


  const checkInstallation = async () => {
    const isStandalone = window.matchMedia("(display-mode: standalone)").matches;
    return isStandalone;
  };

  if (isLoading || isInstalling || appInstalled) {
    return (
      <SplashScreen
        isInstalling={isInstalling}
        installError={installError}
        retryInstall={handleInstall}
        checkInstallation={checkInstallation}
        appInstalled={appInstalled}
      />
    );
  }

  return (
    <Navigator
      renderPage={(route, navigator) => {
        if (!route || !navigator) return null;
        const { title, component: Component, isRenderToolbar } = route;
        return (
          <Page
            renderToolbar={() =>
              isRenderToolbar ? renderToolbar(title, navigator) : null
            }
            contentStyle={{ padding: 10 }}
          >
            <Component
              key={route.key}
              route={route}
              navigator={navigator}
              setIsLoggedIn={setIsLoggedIn}
              isLoggedIn={isLoggedIn}
            />
          </Page>
        );
      }}
      initialRoute={
        isLoggedIn
          ? {
              key: "home",
              title: "Home Screen",
              component: (props) => <HomeScreen {...props} />,
              isRenderToolbar: false,
            }
          : {
              key: "login",
              title: "Login Screen",
              component: (props) => <LoginScreen {...props} />,
              isRenderToolbar: false,
            }
      }
    />
  );
}

export default App;
